export default __webpack_public_path__ + "static/media/discord.9d186a36.svg";